/** Most photos one item photo request can hold, across all of its steps. */
export const MAX_ITEM_PHOTO_CAPTURES = 10;

/** Photos a guidance step asks for when it sets no minimum or maximum. */
export const DEFAULT_STEP_PHOTO_COUNT = 1;
